/* src/app/components/case/download-briefcase/download-briefcase.component.scss */
.comments {
  color: gray;
}
:host-context(.dark-theme) .mat-mdc-table .mat-mdc-cell.mat-column-title {
  color: white;
}
:host-context(.dark-theme) .mat-mdc-card:not([class*=mat-elevation-z]) {
  background-color: #2c2c2c;
}
:host-context(.dark-theme) .comments {
  color: #a7a7a7;
}
/*# sourceMappingURL=download-briefcase.component.css.map */
